import React, { Component } from 'react';

import UsersTable from './UsersTable';
import UserEditor from './UserEditor';

const blankUser = {
  _id: '',
  lecturerId: '',
  password: '',
  fileUrl: '',
  fileName: '',
  fullname: '',
  role: [2],
  email: '',
};

class Users extends Component {
  state = {
    showUserEditor: false,
    user: { ...blankUser },
    userEditorType: undefined,
  }

  showUserEditor = (user) => {
    let item;
    let info;
    let type;
    if (user) {
      item = 'Sửa người dùng';
      type = 'edit';
      info = { ...user };
    } else {
      item = 'Tạo người dùng';
      type = 'create';
      info = { ...blankUser };
    }
    //this.props.handleChangeBreadCrumb('push', item);
    this.setState({
      showUserEditor: true,
      user: info,
      userEditorType: type,
    });
  }

  closeUserEditor = () => {
    //this.props.handleChangeBreadCrumb('pop');
    this.setState({
      showUserEditor: false,
      user: { ...blankUser },
      userEditorType: undefined,
    });
  }

  render() {
    const { showUserEditor, user, userEditorType } = this.state;
    return showUserEditor ?
      <UserEditor
        user={user}
        type={userEditorType}
        closeUserEditor={this.closeUserEditor}
        formItemLayout={this.props.formItemLayout}
        tailFormItemLayout={this.props.tailFormItemLayout}
      /> :
      <UsersTable
        showUserEditor={this.showUserEditor}
        formItemLayout={this.props.formItemLayout}
        tailFormItemLayout={this.props.tailFormItemLayout}
      />;
  }
}

export default Users;



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/Users/Users.js